import React, { FC } from 'react'

import { FormikFormProps } from '../../../form/FormikForm'
import { FormFieldInputProps } from '../../../form/fields/FormFieldInput'
import { FormSubmitButtonProps } from '../../../form/FormSubmitButton'
import FormikField from '../../../form/FormikField'
import { FormErrorsProps } from '../../../form/FormErrors'
import { CardProps } from '../../../Card'
import { LinkProps } from '../../../Link'
import { ActionButtonProps } from '../../../ActionButton'

import * as SC from './styled'

export type LoginValues = {
  email: string
  password: string
}

export type LoginProps = {
  className?: string
  header: CardProps['header']
  content: {
    title: string
    formikForm: FormikFormProps<LoginValues>
    fields: {
      email: FormFieldInputProps
      password: FormFieldInputProps
    }
    forgotPassword: LinkProps
    errors?: FormErrorsProps['errors']
    submitButton: FormSubmitButtonProps
    textDivider: string
    sso: ActionButtonProps
  }
}

const Login: FC<LoginProps> = ({
  className,
  header,
  content: { title, formikForm, fields, forgotPassword, submitButton, sso, textDivider, errors },
}) => {
  return (
    <SC.CardWrapper className={className} header={header}>
      <SC.Title>{title}</SC.Title>
      <SC.Form className={className} {...formikForm}>
        <SC.Fields>
          <FormikField {...fields.email} Component={SC.FieldText} />
          <FormikField {...fields.password} type="password" Component={SC.FieldText} />
        </SC.Fields>
        <SC.LinkWrapper>
          <SC.ForgotPassword {...forgotPassword} />
        </SC.LinkWrapper>
        {errors && <SC.Errors errors={errors} />}
        <SC.SubmitButton {...submitButton} />
        <SC.TextDivider>{textDivider}</SC.TextDivider>
        <SC.SSO {...sso} />
      </SC.Form>
    </SC.CardWrapper>
  )
}

export default Login
